<template>
  <div class="my-homework">
    <div class="header">{{ $t("jobManagementV2.jobManagement") }}</div>
    <div class="homework-table">
      <el-table
        border
        height="100%"
        :show-header="false"
        :data="homeworkList"
        :expand-row-keys="expandRowKeys"
        row-key="createTime"
        @row-click="handleRowClick"
      >
        <el-table-column align="left" class-name="createTime">
          <template slot-scope="{ row }">{{
            $moment(row.createTime).format("YYYY-MM-DD")
          }}</template>
        </el-table-column>
        <el-table-column align="left" type="expand">
          <template slot-scope="{ row }">
            <ul>
              <li v-for="item in row.homeworkList" :key="item.id">
                <div class="homework-top">
                  <div class="homework-title">
                    <el-tooltip
                      effect="dark"
                      popper-class="task-name-tooltip"
                      :disabled="item.taskName && item.taskName.length <= 20"
                      :content="item.taskName"
                      placement="top"
                    >
                      <span>{{ item.taskName | textHiddenTail(20) }}</span>
                    </el-tooltip>
                    <span
                      :class="`homework-status status-${statusFormat(item, 1)}`"
                      >{{ statusFormat(item, 2) }}</span
                    >
                  </div>
                  <div class="homework-tip" v-if="statusFormat(item, 1) === 1">
                    {{ $t("managementV2.awaitTeaher") }}
                  </div>
                  <div class="homework-tip" v-if="statusFormat(item, 1) === 3">
                    {{ $t("managementV2.adjustmentSubmit") }}
                  </div>
                  <div
                    class="homework-tip homework-score"
                    v-if="statusFormat(item, 1) === 4"
                  >
                    {{ item.manualScore }}分
                  </div>
                </div>
                <div class="homework-desc">
                  <div class="desc-left">
                    <div>
                      {{
                        $i18n.locale === "zh"
                          ? item.langDesc.replace(">", " — ")
                          : `${$langCase[item.sourceLang]} — ${
                              $langCase[item.targetLang]
                            }`
                      }}
                    </div>
                    <div>
                      {{
                        $i18n.locale === "zh"
                          ? item.domainName
                          : $domainCase[item.domainCode]
                      }}
                    </div>
                    <div class="homework-progress">
                      <el-progress
                        :percentage="item.progress > 100 ? 100 : item.progress"
                      ></el-progress>
                    </div>
                  </div>
                  <div class="desc-right">
                    <div>
                      {{ $t("jobManagementV2.allotTeacher") }}：<span>{{
                        item.userName
                      }}</span>
                    </div>
                    <div>
                      {{ $t("assignTaskV2.deadLine") }}：<span>{{
                        item.limitTime
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="homework-action">
                  <el-tooltip
                    effect="dark"
                    :content="$t('common.view')"
                    placement="top"
                  >
                    <div class="icon-preview" @click="handleDetail(item)"></div>
                  </el-tooltip>
                  <el-tooltip
                    effect="dark"
                    :content="$t('homeworkManage.downloadJob')"
                    placement="top"
                  >
                    <div
                      class="icon-download"
                      v-if="[0, 2, 3].includes(statusFormat(item, 1))"
                      @click="handleDownload(item)"
                    ></div>
                  </el-tooltip>
                  <el-tooltip
                    effect="dark"
                    :content="$t('homeworkManage.offlineUpload')"
                    placement="top"
                  >
                    <div
                      class="icon-upload"
                      v-if="[0, 2, 3].includes(statusFormat(item, 1))"
                      @click="handleUpload(item)"
                    ></div>
                  </el-tooltip>
                </div>
              </li>
            </ul>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="homework-pagination">
      <el-pagination
        background
        layout="prev, pager, next, sizes"
        :pager-count="5"
        :current-page="query.page"
        :page-sizes="[20, 30, 40]"
        :page-size="query.rows"
        :total="totalRows"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
    <task-upload
      :visible="uploadVisible"
      :taskInfo="taskInfo"
      @handleCancel="handleUploadCancel"
    >
    </task-upload>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { apiRoot } from "@/services/ajax.js";
import {
  queryPageHomework,
  outLineEditDownload,
} from "@/services/jobManagement";

import TaskUpload from "./components/task-upload";

export default {
  name: "MyHomework",
  beforeRouteEnter(to, from, next) {
    if (from.name == null) {
      console.log("刷新进入");
      next((vm) => {
        vm.isRefushGoing = true;
      });
    } else {
      next((vm) => {
        vm.isRefushGoing = false;
      });
    }
  },
  components: {
    TaskUpload,
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.layout.userInfo,
      navInfo: (state) => state.layout.navInfo,
      isRouteDataReady: (state) => state.layout.isRouteDataReady,
    }),
  },
  data() {
    return {
      homeworkList: [],
      expandRowKeys: [],
      query: {
        filter: {
          userId: JSON.parse(localStorage.userInfo).id,
        },
        page: 1,
        rows: 20,
      },
      totalRows: 0,
      uploadVisible: false,
      taskInfo: {},
      isRefushGoing: false, //刷新进入
    };
  },
  watch: {
    navInfo: {
      deep: true,
      handler(newVal, oldVal) {
        let flag = newVal.find((item) => item.code == "my_homework");
        if (!flag && this.isRouteDataReady &&this.isRefushGoing) {
          this.isRefushGoing = false
          let url = "/home/intelligentTranslation/textTranslation";
          this.$router.replace({ path: url });
        }
      },
    },
  },
  mounted() {
    this.getPageHomework();
  },
  methods: {
    async getPageHomework() {
      let { success, list } = await queryPageHomework(this.query);
      if (success) {
        this.homeworkList = list;
        this.expandRowKeys = list.map((item) => item.createTime);
      }
    },
    handleSizeChange(val) {
      this.query.rows = val;
      this.getPageHomework();
    },
    handleCurrentChange(val) {
      this.query.page = val;
      this.getPageHomework();
    },
    statusFormat(item, type) {
      let status = item.finish; // 任务状态
      let scoreStatus = item.scoreStatus;
      if (scoreStatus === 0) {
        switch (status) {
          case 0:
            return type === 1 ? 0 : this.$t("managementV2.notSubmitted");
          case 2:
            return type === 1 ? 2 : this.$t("managementV2.notSubmitted");
          case 1:
            return type === 1 ? 1 : this.$t("managementV2.submitted");
          case 3:
            return type === 1 ? 3 : this.$t("managementV2.returned");
        }
      } else if (scoreStatus === 1) {
        switch (status) {
          case 1:
            return type === 1 ? 4 : this.$t("jobManagementV2.completed");
        }
      }
    },
    handleRowClick(row) {
      if (this.expandRowKeys.includes(row.createTime)) {
        this.expandRowKeys = this.expandRowKeys.filter(
          (i) => i !== row.createTime
        );
      } else {
        this.expandRowKeys.push(row.createTime);
      }
    },
    handleDetail(row) {
      sessionStorage.setItem("fileName", row.taskName);
      let routeData = this.$router.resolve({
        path: "/neweditor",
        query: {
          key: this.$Base64.encode(
            JSON.stringify({
              sourceLang: row.sourceLang,
              targetLang: row.targetLang,
              taskName: row.taskName,
              wordNum: row.sourceWordNum,
              project: 3,
              userId: this.userInfo.id,
              transStatus: 1,
              fileSuffix: row.fileUsableSuffix,
              transModel: row.transModel,
              // 老版参数
              fileId: row.fileId,
              projectId: row.projectId,
              isSplit: true,
              type: "school",
              taskType: row.taskType,
              taskId: row.id,
              "type-school": "student-homework",
              // 学生进编辑器必须传递companyCode，这个companyCode为老师的
              companyCode: row.companyCode,
            })
          ),
        },
      });
      window.open(routeData.href, "_self");
    },
    async handleDownload(item) {
      let { success, result } = await outLineEditDownload({
        fileId: item.fileId,
        taskId: item.id,
      });
      if (success) {
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = apiRoot(
          `/common/downloadFile?fileName=${
            item.taskName + result.substring(result.lastIndexOf("."))
          }&filePath=${result}`
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    },
    handleUpload(item) {
      this.taskInfo = {
        taskId: item.id,
        fileId: item.fileId,
      };
      this.uploadVisible = true;
    },
    handleUploadCancel() {
      this.uploadVisible = false;
      this.taskInfo = {};
    },
  },
};
</script>

<style lang="less" scoped>
.my-homework {
  text-align: left;
  line-height: 1.5;
  background: #fff;
  height: 100%;
  padding: 15px;
  box-sizing: border-box;
}
.header {
  font-size: 16px;
  line-height: 16px;
  color: #333333;
  font-weight: bold;
  padding-left: 8px;
  position: relative;
  margin-bottom: 15px;
  &::before {
    display: inline-block;
    width: 2px;
    height: 14px;
    content: "";
    background: #0078fc;
    position: absolute;
    left: 0;
    top: 1px;
  }
}
.homework-table {
  height: calc(100% - 16px - 15px - 32px - 15px);
  /deep/.el-table__row {
    background: #f6f7fb;
  }
  /deep/.el-table__expanded-cell {
    padding: 0;
  }
  /deep/.createTime {
    border-right: none;
  }
  li {
    height: 80px;
    box-sizing: border-box;
    padding: 15px 20px;
    border-bottom: 1px solid #f2f2f2;
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    position: relative;
    .homework-top {
      display: flex;
    }
    .homework-title {
      height: 20px;
      font-weight: bold;
      font-size: 16px;
      display: flex;
      align-items: center;
    }
    .homework-status {
      // min-width: 60px;
      padding: 0 10px;
      height: 20px;
      color: #fff;
      border-radius: 4px;
      font-size: 12px;
      line-height: 20px;
      text-align: center;
      margin-left: 20px;
    }
    .status-0,
    .status-2 {
      background: #909399;
    }
    .status-1 {
      background: #00b42a;
    }
    .status-3 {
      background: #f56c6c;
    }
    .status-4 {
      background: #0078fc;
    }
    .homework-tip {
      color: #999;
      margin-left: 50px;
      font-size: 12px;
    }
    .homework-score {
      color: #f9b90b;
      font-size: 22px;
      transform: translateY(-10px);
    }
    .homework-desc {
      width: 100%;
      line-height: 12px;
      font-size: 12px;
      display: flex;
      justify-content: space-between;
      .desc-left,
      .desc-right {
        display: flex;
        align-items: center;
      }
      div {
        color: #999999;
      }
      div + div {
        padding-left: 20px;
        span {
          color: #333333;
        }
      }
      .homework-progress {
        display: inline-block;
        width: 150px;
        /deep/.el-progress__text {
          font-size: 12px !important;
        }
      }
    }
    .homework-action {
      position: absolute;
      top: 15px;
      right: 20px;
      display: flex;
      div {
        width: 20px;
        height: 20px;
        cursor: pointer;
      }
      div + div {
        margin-left: 20px;
      }
      .icon-preview {
        background: url("~@/assets/imgs/homework/icon-preview.png") no-repeat
          center center;
        &:hover {
          background: url("~@/assets/imgs/homework/icon-preview-pre.png")
            no-repeat center center;
        }
      }
      .icon-download {
        background: url("~@/assets/imgs/homework/icon-download.png") no-repeat
          center center;
        &:hover {
          background: url("~@/assets/imgs/homework/icon-download-pre.png")
            no-repeat center center;
        }
      }
      .icon-upload {
        background: url("~@/assets/imgs/homework/icon-upload.png") no-repeat
          center center;
        &:hover {
          background: url("~@/assets/imgs/homework/icon-upload-pre.png")
            no-repeat center center;
        }
      }
    }
  }
  li:last-child {
    border-bottom: none;
  }
}
.homework-pagination {
  text-align: center;
  margin-top: 15px;
  height: 32px;
  line-height: 32px;
  /deep/.btn-prev {
    background: none;
    border: 1px solid #c0cccc;
  }
  /deep/.number {
    background: none;
    border: 1px solid #c0cccc;
  }
  /deep/.el-icon-more {
    background: #ffffff;
  }
  /deep/.btn-next {
    background: none;
    border: 1px solid #c0cccc;
  }
  /deep/.el-pagination__sizes {
    margin-right: -10px;
  }
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    border: 1px solid #0087fc;
    border-radius: 4px;
    background: #ffffff;
    color: #0078fc;
  }
}
</style>

<style lang="less">
.task-name-tooltip {
  max-width: 30%;
}
</style>